import { useEffect, useState } from 'react'

/**
 * Returns false during SSR and on the first client render, then the real viewport
 * match after mount. Prevents React 18 hydration mismatches from reading window
 * during render (Preact was more permissive).
 */
const useSSRSafeMobile = (breakpoint = 767): boolean => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const update = () => setIsMobile(window.innerWidth < breakpoint)
        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [breakpoint])

    return isMobile
}

export default useSSRSafeMobile
